namespace Controlli {
    export namespace Donut {
        export function Render(options: ChartOptions) {
            ChartsGlobal.RenderChart(options.DivIdValue, InitParams(options))
        }

        function InitParams(initOptions: ChartOptions): Object {
            let radiusHeight = (initOptions.ChartHeight == null || initOptions.ChartHeight == 0 ? 305 : initOptions.ChartHeight);
            let donutRadiusSize = (initOptions.PlotSize == null || initOptions.PlotSize == 0 ? "70%" : initOptions.PlotSize + "%");
            let showLegend = false;
            let showDataLabels = false;

            let colorArray = Controlli.Utility.GetChartColorsArray(initOptions.Colors)


            let result = {
                series: initOptions.Series,
                labels: initOptions.Labels,
                colors: colorArray,
                chart: {
                    id: initOptions.ChartId,
                    height: radiusHeight,
                    type: initOptions.Type,
                    defaultLocale: initOptions.DefaultLocal,
                },
                plotOptions: {
                    pie: {
                        offsetX: 0,
                        offsetY: 0,
                        donut: {
                            size: donutRadiusSize,
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: "18px",
                                    offsetY: -6,
                                },
                                value: {
                                    show: true,
                                    fontSize: "20px",
                                    color: "#343a40",
                                    fontWeight: 500,
                                    offsetY: 5,
                                    formatter: function (val) { return val }
                                },
                                total: {
                                    show: true,
                                    fontSize: "15px",
                                    label: initOptions.TotalLabel,
                                    color: "#9599ad",
                                    fontWeight: 500,
                                    formatter: function (w) {
                                        return (w.globals.seriesTotals.reduce(function (a, b) {
                                            return a + b;
                                        }, 0));
                                    }
                                },
                            },
                        },
                    },
                },
                dataLabels: {
                    enabled: showDataLabels,
                },
                legend: {
                    show: showLegend,
                },
                yaxis: {
                    labels: {
                        formatter: function (value) { return value; },
                    },
                },
                stroke: {
                    lineCap: "round",
                    width: 2,
                },
            };

            return result;
        }

        //Contain the parameters for setting up the donut chart
        export class ChartOptions extends ChartsGlobal.BaseChart {
            TotalLabel: string;
            FunctionValue: string;
            FunctionTotal: string;
            Series: Array<number>;
        }
    }
}